<main id="main" class="Main">
  <mat-progress-bar
    class="Main__progressbar"
    [mode]="progressbar.mode"
    [class.Main__progressbar--show]="progressbar.show"
  ></mat-progress-bar>
  <router-outlet></router-outlet>
</main>
